﻿export class HttpPendingRequestService {

    public timeoutPromises:Array<any> = [];

    static $inject = ["$q"];
    
    public constructor(private $q: ng.IQService) {
        
    }

    public newTimeout(): ng.IPromise<any> {
        var timeoutPromise = this.$q.defer();
        this.timeoutPromises.push(timeoutPromise);
        return timeoutPromise.promise;
    }

    public cancelAll(): ng.IPromise<any>  {
        var deferred = this.$q.defer();

        this.$q.all(this.timeoutPromises).then(() => this.$q.when(deferred.resolve()));

        angular.forEach(this.timeoutPromises,
            (timeoutPromise: any) => {
                timeoutPromise.promise.isGloballyCancelled = true;
                timeoutPromise.resolve();
            });

        this.timeoutPromises = [];
        
        return deferred.promise;
    }

}
